<script>
import _ from 'lodash';
import { helpers as referralHelpers } from '@/store/modules/referral';
import { required } from '@/utils/propTypes';
import { appendQueryParam } from '@/utils';

export default {
  props: {
    provider: required(String),
  },
  data: () => ({ isLoading: false }),
  computed: {
    ...referralHelpers.mapState({ referralCode: 'referralCode' }),
    href() {
      const appendQueryParams = _.flow([
        appendQueryParam('activity', 'signup'),
        appendQueryParam('referralCode', this.referralCode),
      ]);
      return appendQueryParams(`/auth/${this.provider}`);
    },
  },
};
</script>

<template>
  <v-btn
    :loading="isLoading"
    :disabled="isLoading"
    block
    outlined
    :href="href"
    @click.native="isLoading = true"
  >
    <v-icon left :size="18"> $vuetify.icons.{{ provider }} </v-icon>
    <v-spacer />
    Continue with {{ provider | capitalize }}
    <v-spacer />
  </v-btn>
</template>
